import { query, proxy_api } from "@core/helpers/graphql";
import { GET_PREFIX_URLS, GET_SEOS, GET_SITEMAP_URLS, GET_SEO_JSON, GET_PREFIX_URL_REDIRECT, GET_PREFIX_URLS_POPUPS, GET_PREFIX_URLS_BANNERS, make_get_prefix_urls } from "./_queries";

const get_sitemap_urls_query = async (options = {}) => {
    const { gql } = options;
    const result = await query(gql || GET_SITEMAP_URLS, options);
    return {
        data: result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
};


const get_seos = async (options = {}) => {
    const { gql } = options;
    const result = await query(gql || GET_SEOS, options);
    return {
        data: result?.data?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
};

const get_seo_json = async (variable = {}, options = {}) => {
    const { gql } = options;
    const result = await query(gql || GET_SEO_JSON, variable, options);

    return {
        data: result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
};

const get_prefix_urls = async (options = {}) => {
    const { gql } = options;

    const result = await query(gql || GET_PREFIX_URLS, options);

    return {
        data: result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
};

/* Same as get_prefix_urls with a caller-supplied query (options.gql) and proper variables. */
const get_prefix_urls_by_gql = async (variables = {}, options = {}) => {
    const { gql } = options;

    const result = await query(gql || GET_PREFIX_URLS, variables);

    return {
        data: result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
};

const get_prefix_urls_popups = async (options = {}) => {
    const { gql } = options;

    const result = await query(gql || GET_PREFIX_URLS_POPUPS, options);

    return {
        data: result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
};

const get_prefix_urls_popups_proxy = async (variables = {}, options = {}) => {
    const { gql } = options;

    const result = await proxy_api({
        type: 'query',
        gql: gql || GET_PREFIX_URLS_POPUPS,
        variables,
        options,
        cacheOptions: {
            name: `popups`,
            ttl: 60 * 5,
            keys: variables
        }
    });

    return {
        data: gql ? result?.data : result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
};

const get_prefix_urls_banners = async (variables = {}, options = {}) => {
    const { gql } = options;

    const result = await query(gql || GET_PREFIX_URLS_BANNERS, variables, options);

    return {
        data: result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
};

const get_prefix_urls_banners_proxy = async (variables = {}, options = {}) => {
    const { gql } = options;

    const result = await proxy_api({
        type: 'query',
        gql: gql || GET_PREFIX_URLS_BANNERS,
        variables,
        options,
        cacheOptions: {
            name: `banners`,
            ttl: 60 * 5,
            keys: variables
        }
    });

    return {
        data: gql ? result?.data : result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
};

const get_prefix_url_redirect = async (options = {}) => {
    const { gql } = options;

    const result = await query(gql || GET_PREFIX_URL_REDIRECT, options);
    return {
        data: result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
};

export { make_get_prefix_urls, get_sitemap_urls_query, get_seos, get_prefix_urls, get_prefix_urls_by_gql, get_seo_json, get_prefix_url_redirect, get_prefix_urls_popups, get_prefix_urls_popups_proxy, get_prefix_urls_banners, get_prefix_urls_banners_proxy };
